import AsyncPopconfirm from './asyncPopconfirm';

export default AsyncPopconfirm;
